<template>
  <v-card
    :class="{'rounded-card px-5 py-5': !$store.getters.user.isAdmin}"
    class="px-0 py-0 my-0 mx-0"
    min-width="90%"
    flat
    v-if="!Utils.isObjectEmpty(selectedUser)">
    <v-card-text class="px-0 py-0">
      <h2 class="accent--text text-capitalize"
          v-if="!$store.getters.user.isAdmin">
          {{ selectedUser.firstName || selectedUser.email }}
      </h2>
      <v-form ref="form">
        <v-row>
          <v-col
            cols="12"
            v-if="edited"
          >
            <v-alert
              dense
              outlined
              type="error"
              class="mb-0"
              v-if="$store.getters.user.isAdmin"
            >
              Debes guardar tus cambios antes de poder editar otro usuario, o de lo contrario debes descartarlos
            </v-alert>
            <v-alert
              dense
              outlined
              type="error"
              class="mb-0"
              v-else
            >
              No olvides guardar tus cambios o descartarlos
            </v-alert>
          </v-col>
          <v-col cols="12" xl="8" lg="8" md="12" sm="12">
            <v-text-field
              color="primary"
              label="Correo Electronico"
              prepend-icon="mdi-email"
              v-model="selectedUser.email"
              disabled
              @keyup="edition"
              v-if="selectedUser.userId"/>
            <v-text-field
              color="primary"
              label="Correo Electronico"
              prepend-icon="mdi-email"
              v-model="selectedUser.email"
              :rules="emailRules"
              required
              @keyup="edition"
              v-if="!selectedUser.userId"/>
            <v-text-field
              color="primary"
              label="Nombre"
              prepend-icon="mdi-account"
              :rules="nameRules"
              required
              @keyup="edition"
              v-model="selectedUser.firstName"/>
            <v-text-field
              color="primary"
              label="Apellido Paterno"
              prepend-icon="mdi-text-short"
              :rules="nameRules"
              required
              @keyup="edition"
              v-model="selectedUser.lastName"/>
            <v-text-field
              color="primary"
              label="Apellido Materno"
              prepend-icon="mdi-text-short"
              @keyup="edition"
              v-model="selectedUser.motherSurname"/>
            <v-text-field
              color="primary"
              label="Teléfono Fijo"
              prepend-icon="mdi-phone-classic"
              v-mask="mask"
              @keyup="edition"
              v-model="selectedUser.phone"/>
            <v-text-field
              color="primary"
              label="Celular"
              prepend-icon="mdi-cellphone-iphone"
              v-mask="mask"
              @keyup="edition"
              v-model="selectedUser.mobile"/>
          </v-col>
          <v-col xl="4" lg="4" md="12" sm="12" xs="12">
            <h2 class="text-h6 primary--text">
              <v-icon dark color="primary">mdi-bell-ring</v-icon>
              Notificaciones
            </h2>
            <v-switch
              v-model="selectedUser.notifications.initialDeposit"
              label="Depósito de facturas"
              color="#5C9DF2"
              @change="edition"
              hide-details/>
            <!-- <v-switch
              v-if="$store.getters.user.syncAllowed"
              v-model="selectedUser.notifications.desyncSAT"
              label="Desincronizacion con SAT MÉXICO"
              color="#5C9DF2"
              hide-details/> -->
            <!-- <v-switch
              v-model="selectedUser.notifications.rejections"
              label="Rechazo de facturas"
              color="#5C9DF2"
              hide-details/> -->
            <!-- <v-switch
              v-model="selectedUser.notifications.nextPayments"
              label="Próximos pagos"
              color="#5C9DF2"
              @change="edition"
              hide-details/>-->
            <!-- <v-switch
              v-model="selectedUser.notifications.sendInvoices"
              @change="edition()"
              label="¿Recibir facturas por correo?"
              color="#5C9DF2"
              hide-details/> -->
            <v-row class="mt-0" v-if="$store.getters.user.isAdmin">
              <v-col cols="12">
                <h2 class="text-h6 primary--text">Permisos de Usuario</h2>
                <v-switch
                  v-model="selectedUser.active"
                  @change="checkActive()"
                  label="¿Tiene acceso a este portal?"
                  color="#5C9DF2"
                  hide-details/>
                <v-switch
                  v-model="selectedUser.isAdmin"
                  :disabled="disabledSwitch"
                  @change="checkAdmin()"
                  label="¿Es usuario administrador?"
                  color="#5C9DF2"
                  hide-details="auto"
                  :rules="adminRules"
                />
                <v-switch
                  v-model="selectedUser.syncAllowed"
                  @change="edition()"
                  label="¿Puede sincronizar facturas SAT MÉXICO?"
                  color="#5C9DF2"
                  hide-details="auto"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row order="1" class="mt-1 mb-2">
          <v-btn
            @click="revertChanges"
            v-if="edited"
            class="my-1 mx-2 font-weight-bold"
            color="error"
          >
            <v-icon>mdi-undo</v-icon>
            DESCARTAR CAMBIOS
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="saveUser"
            v-if="selectedUser.userId"
            class="my-1 mx-2 font-weight-bold"
            :class="{'mx-4': !$store.getters.user.isAdmin }"
            color="primary"
          >
            <v-icon left>mdi-content-save</v-icon>
            Actualizar datos
          </v-btn>
          <v-btn
            v-if="!selectedUser.userId"
            @click="saveUser"
            class="mx-2 font-weight-bold"
            :class="{'mx-4': !$store.getters.user.isAdmin }"
            color="primary"
          >
            <v-icon left>mdi-content-save</v-icon>
            Guardar nuevo usuario
          </v-btn>
          <v-btn
            @click="$emit('removeUser', userKey)"
            class="mx-2 font-weight-bold"
            :class="{'mx-4': !$store.getters.user.isAdmin }"
            dark
            color="orange darken-3"
            v-if="!selectedUser.userId"
          >
            <v-icon left>mdi-restore</v-icon>
            Cancelar
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import ClientUserService from '@/services/ClientUserService'
import Utils from '@/common/utils.js'
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'User',
  props: ['user', 'userKey', 'adminsCount'],
  data () {
    return {
      Utils: Utils,
      disabledSwitch: false,
      edited: false,
      isOriginalAdmin: false,
      selectedUser: {},
      mask: '(###)-###-##-##',
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingresa un email válido (Ejemplo: correo@miempresa.com)',
        v => (v || '').indexOf(' ') < 0 || 'Los espacios no están permitidos'
      ],
      nameRules: [
        v => !!v || 'El nombre es requerido'
      ],
      adminRules: [
        v => (!v && this.adminsCount < 2 && this.isOriginalAdmin) ? 'No olvides que debe existir al menos un administrador' : true
      ]
    }
  },
  mounted () {
    this.setSelectedUser()
    this.checkOriginalAdmin()
  },
  methods: {
    setSelectedUser () {
      if (this.user.userId === this.$store.getters.user.userId) {
        this.selectedUser = _.cloneDeep(this.$store.getters.user)
      } else {
        this.selectedUser = _.cloneDeep(this.user)
      }
    },
    checkOriginalAdmin () {
      if (this.user.isAdmin) {
        this.isOriginalAdmin = true
      } else {
        this.isOriginalAdmin = false
      }
    },
    revertChanges () {
      this.edited = false
      this.setSelectedUser()
      this.$emit('onEnabled')
    },
    async saveUser () {
      if (!this.$refs.form.validate()) {
        return
      }
      const loader = this.$loading.show()
      let data
      if (this.selectedUser.userId) {
        try {
          data = await ClientUserService.update(this.selectedUser)
          this.edited = false
          await this.$emit('loadRecord')
          await this.$emit('onEnabled')
          await this.$emit('onUserUpdate')
          loader.hide()
          this.showSucessMessage(data.message)
        } catch (error) {
          loader.hide()
          this.showErrorMessage(error.response?.data?.message || error.message)
        }
      } else {
        try {
          this.selectedUser.addedBy = this.$store.getters.user.userId
          data = await ClientUserService.create(this.selectedUser)
          Vue.set(this.selectedUser, 'userId', data.user.userId)
          this.edited = false
          await this.$emit('loadRecord')
          await this.$emit('onEnabled')
          await this.$emit('onUserUpdate')
          loader.hide()
          this.showSucessMessage(data.message)
        } catch (error) {
          loader.hide()
          this.showErrorMessage(error.response?.data?.message || error.message)
        }
      }
    },
    checkActive () {
      this.edition()
      if (!this.selectedUser.active) {
        this.selectedUser.isAdmin = false
      }
    },
    checkSyncAllowed () {
      this.edition()
      if (!this.selectedUser.active) {
        this.selectedUser.isAdmin = false
      }
    },
    onUserChange () {
      this.$emit('onDisabled')
    },
    checkAdmin () {
      this.edition()
      if (this.selectedUser.isAdmin) {
        this.selectedUser.active = true
      } else {
        if (this.adminsCount < 2 && this.isOriginalAdmin) {
          // alert('debe existir por lo menos un admin')
        }
      }
    },
    edition () {
      if (_.isEqual(this.selectedUser, this.user)) {
        this.edited = false
        this.$emit('onEnabled')
      } else {
        this.edited = true
        this.$emit('onDisabled')
      }
    },
    showErrorMessage (message) {
      this.$swal({
        title: '¡No pudimos guardar tus datos!',
        html: this.$t(message),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#1374F2',
        showCloseButton: true,
        allowOutsideClick: false
      })
    },
    showSucessMessage (message) {
      this.$swal({
        title: '¡Éxito!',
        html: this.$t(message),
        icon: 'success',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#1374F2',
        showCloseButton: true,
        allowOutsideClick: false
      })
    }
  },
  watch: {
    user: function (newVal, odlVal) {
      this.selectedUser = _.cloneDeep(newVal)
      this.checkOriginalAdmin()
      this.$emit('onEnabled')
    }
  }
}
</script>
